import {UserModel} from '../models/user.model';

export class AuthService {

  public user: UserModel = JSON.parse(window.localStorage.getItem('user'));

  login(username: string, password: string) {
    this.user = new UserModel(password, username);
    window.localStorage.setItem('user', JSON.stringify(this.user));
    // this.isAuthenticated = true;
  }

  logout() {
    // console.log('do logout');
    // this.isAuthenticated = false;
    this.user = null;
    window.localStorage.clear();
  }

  isLoggedIn(): boolean {
    return this.isAuthenticated;
  }

  get isAuthenticated(): boolean {
    if (this.user !== undefined && this.user !== null) {
      return true;
    } else {
      return false;
    }
  }

}
